<template>
  <transition name="el-fade-in-linear">
	<div class="backborder3plus sys-active-join-all" v-loading="joinquery.loading">
		<div class="sys-offers-details">
			<div :class="showjoinlabel==false ? 
				 'sys-offers-detail-isjoin-base-warning sys-offers-detail-isjoin-no' : 
				 'sys-offers-detail-isjoin-base-warning sys-offers-detail-isjoin-yes'" 
				 v-if="isjoin && jointype==1">已报名，待审核
		    </div>
			<div :class="showjoinlabel==false ? 
				 'sys-offers-detail-isjoin-base-success sys-offers-detail-isjoin-no' : 
				 'sys-offers-detail-isjoin-base-success sys-offers-detail-isjoin-yes'" 
				 v-if="isjoin && jointype==2">已报名，已审核
		    </div>
			<div :class="showjoinlabel==false ? 
				 'sys-offers-detail-isjoin-base-danger sys-offers-detail-isjoin-no' : 
				 'sys-offers-detail-isjoin-base-danger sys-offers-detail-isjoin-yes'" 
				 v-if="isjoin && jointype==3">已报名，审核失败
		    </div>
			<div class="sys-offers-details-main">
				<div class="sys-offers-details-main-line1"></div>
				<div class="sys-offers-details-main-name">
					<span v-if="joinquery.type==1">新人专享</span>
					<span v-if="joinquery.type==4">限时秒杀</span> 
					<span v-if="joinquery.type==3">特卖活动</span> 
					<span v-if="joinquery.type==6">新品促销</span>  
					<span> - </span> 
					<span>{{joinquery.name}}</span>
				</div>
				<div class="sys-offers-details-main-time">
					<span>报名时间：{{joinquery.jointime}}</span> 
					<i class="sys-offers-details-main-active-status sys-active-status-end" v-if="joinquery.joinstatus==1">未开始</i>
					<i class="sys-offers-details-main-active-status sys-active-status-doing" v-if="joinquery.joinstatus==2">进行中</i>
					<i class="sys-offers-details-main-active-status sys-active-status-end" v-if="joinquery.joinstatus==3">已结束</i>
				</div>
				<div class="sys-offers-details-main-time">
					<span>活动时间：{{joinquery.activetime}}</span>
					<span v-if="joinquery.cuteverystarttime!=''" style="color:#F56C6C">（活动期间每天 {{joinquery.cuteverystarttime}}开始，{{joinquery.cuteveryendtime}} 结束）</span> 
					<i class="sys-offers-details-main-active-status sys-active-status-end" v-if="joinquery.activestatus==1">未开始</i>
					<i class="sys-offers-details-main-active-status sys-active-status-doing" v-if="joinquery.activestatus==2">进行中</i>
					<i class="sys-offers-details-main-active-status sys-active-status-end" v-if="joinquery.activestatus==3">已结束</i>
				</div>
				<div class="sys-offers-details-main-time" v-if="joinquery.reason!=''" style="color:#F56C6C;width:100%;margin-left:1.5%">
					<span>失败原因：{{joinquery.reason}}</span> 
				</div>
			</div>
		</div>
		<el-steps :active="stepindex" finish-status="success" style="border-bottom:1px dashed #dddddd;padding-bottom:30px">
			<el-step title="了解详情" icon="el-icon-view"></el-step>
			<el-step title="商品信息设置" icon="el-icon-setting"></el-step>
			<el-step title="设置参加活动时间" icon="el-icon-edit"></el-step>
			<el-step title="完成报名" icon="el-icon-check"></el-step>
		</el-steps>

		<!-- 了解详情 -->
		<div class="sys-offers-details-lists-info" v-if="stepindex==0">
			<span class="sys-offers-details-lists-info-title">活动介绍</span>
			<div class="sys-offers-details-lists-info-main" v-html="joinquery.content"></div>
		</div>
		<!-- 商品信息设置 -->
		<div class="sys-offers-details-lists-info" v-if="stepindex==1 || stepindex==2">
			<div class="sys-offers-details-lists-info-main">
			<el-form :inline="true" class="demo-form-inline" size="small" filterable clearable>	
				<el-form-item>
					<el-button type="danger" size="small" @click="addmallgoods">新增商品</el-button>
					<el-button type="danger" size="small" @click="settingpricemore" :disabled="joinquery.unified > 0 ? true : false">批量设置活动价</el-button>
					<div style="display:inline-block;margin-left:20px;font-size:13px;font-weight:550;color:#f56c6c" v-if="joinquery.unified > 0">平台活动商品统一销售价：￥{{joinquery.unified}}</div>
					<div style="display:inline-block;font-size:13px;font-weight:500;color:#f56c6c;width:100%;margin-top:10px">注：已审核通过的商品切勿更改任何参数，否则将导致商品需要重新进行审核</div>
					<!-- <div>{{ joinquery.type }}</div> -->
				</el-form-item>
		    </el-form>
			<el-table :data="joinquery.joininfos" >
				<el-table-column label="sku" width="120" fixed="left">
					<template slot-scope="scope">
						<span class="sys-offers-details-rights-sku">{{scope.row.sku}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="400" fixed="left">
					<template slot-scope="scope">
						<div class="sys-offers-details-imgs">
							<i :class="scope.row.isgrounding==0 ? 'sys-offers-details-imgs-up' : 'sys-offers-details-imgs-down'">{{scope.row.isgrounding==0 ? '已上架' : '已下架'}}</i>
							<img :src="scope.row.img!='' ? scope.row.img : require('../../assets/goodsdefault.png')"/>
						</div>
						<div class="sys-offers-details-rights">
							<span class="sys-offers-details-rights-name">{{scope.row.name}}</span>
							<span class="sys-offers-details-rights-spec">{{scope.row.property_name}}</span>
							<span class="sys-offers-details-rights-agent">{{scope.row.agentname}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="审核结果" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status" v-if="scope.row.verifyerstatus==1">待审核</span>
						<span class="sys-offers-details-status" v-if="scope.row.verifyerstatus==2">通过</span>
						<span class="sys-offers-details-status" v-if="scope.row.verifyerstatus==3">失败</span>
						<span class="sys-offers-details-status" style="color:#F56C6C" v-if="scope.row.verifyerstatus==3 && scope.row.reason!=null && scope.row.reason!=''">{{scope.row.reason}}</span>
					</template>
				</el-table-column>
				<el-table-column label="所属品牌" align="center" width="140">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.brandname}}</span>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==1">未授权</i>
						<i class="sys-offers-details-brand-grant-yes" v-if="scope.row.brandname!='' && scope.row.brandtype==2">已授权</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==3">授权失败</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==4">授权未开始</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==5">授权到期</i>
					</template>
				</el-table-column>
				<el-table-column label="重量（kg）" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.weight}}</span>
					</template>
				</el-table-column>
				<el-table-column label="单位" align="center" width="100">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.unit}}</span>
					</template>
				</el-table-column>
				<el-table-column label="销售价格" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.property_price}}</span>
					</template>
				</el-table-column>
				<el-table-column label="活动价" align="center" width="120">
					<template slot-scope="scope">
						<el-input placeholder="请输入活动价" v-model="scope.row.active_price" @blur="changeprice(scope.row)" size="small" clearable :disabled="joinquery.unified > 0 ? true : false"/>
					</template>
				</el-table-column>
				<el-table-column label="商品参加活动总数量" align="center" width="150">
					<template slot-scope="scope">
						<el-input placeholder="商品参加活动总数量" v-model="scope.row.inventory" @blur="changeinventory(scope.row)" size="small" clearable/>
					</template>
				</el-table-column>
				<el-table-column label="可用库存数量" align="center" width="140">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.lastinventorys}}</span>
					</template>
				</el-table-column>

				<el-table-column label="是否限购" align="center" width="120">
					<template slot-scope="scope">
						<el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="scope.row.islimit" @change="changeislimit(scope.row)"/>
					</template>
				</el-table-column>
				<el-table-column label="限制规则" align="center" width="240">
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<el-select 
								v-model="scope.row.limit_rule"
								size="small"
								placeholder="请选择"
								style="width: 130px;margin-right: 5px;flex-shrink: 0;"
								@change="changeislimitnums(scope.row)"
							>
								<el-option label="每人限购数量" value="1"></el-option>
								<el-option v-if="!['3','6'].includes(joinquery.type)" label="每店限购数量" value="2"></el-option>
							</el-select>
							<el-input placeholder="请输入限购数量" v-model="scope.row.limitsingle" @blur="changeislimitnums(scope.row)" size="small" :disabled="scope.row.islimit==0 ? true : false" clearable/>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="120" fixed="right">
					<template slot-scope="scope">
						<el-button type="danger" size="small" icon="el-icon-delete" circle @click="delactivegoods(scope.row)" />
					</template>
				</el-table-column>
			</el-table>
			</div>
		</div>
		<!-- 填写基本信息 -->
		<div class="sys-offers-details-lists-info" v-if="stepindex==3 || stepindex==4">
			<div class="sys-offers-details-lists-info-main">
			<el-form :inline="true" class="demo-form-inline" size="small" filterable clearable>	
				<el-form-item label="参加活动时间">
					<el-date-picker 
					 	type="datetimerange" 
						range-separator="至" 
						start-placeholder="开始日期" 
						end-placeholder="结束日期" 
						value-format="yyyy-MM-dd HH:mm:ss" 
						:unlink-panels="false"
						v-model="joinquery.myjoindate"
						@change="changemytime" 
					/>
				</el-form-item>
		    </el-form>
			</div>
		</div>
		<div slot="footer" class="dialog-footer" style="text-align:right">
            <el-button size="small" type="primary" @click="clickuppage" :disabled="stepindex==0 ? true : false">上一步</el-button>
            <el-button size="small" type="primary" @click="clicknext" v-if="stepindex < 3">下一步</el-button>
			<el-button size="small" type="primary" @click="finishjoin" v-if="stepindex==3">完 成</el-button>
        </div>


		<!-- 新增商品信息 -->
		<el-dialog title="商品信息列表" :visible.sync="addgoodsDialog" width="70%" top="10vh">
			<el-form :inline="true" class="demo-form-inline" size="small">	
				<el-form-item v-if="saleagents.length > 1">
					<el-select v-model="addgoodsquery.agentid" @change="addgoodsquery.ischange=true" clearable remote  filterable  placeholder="请选择供应商">
						<el-option v-for="(item,index) in saleagents" :label="item.name" :value="item.id" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-select v-model="addgoodsquery.isgrounding" @change="addgoodsquery.ischange=true" clearable remote  filterable  placeholder="请选择商品上下架状态">
						<el-option v-for="(item,index) in groundinglists" :label="item.name" :value="item.id" :key="index"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
				<el-select v-model="addgoodsquery.brandid" clearable remote  filterable placeholder="按品牌" @change="addgoodsquery.ischange=true">	            
					<el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
						<span style="float: left">{{item.name}}</span>
						<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					</el-option>              
				</el-select>          
				</el-form-item>
				<el-form-item>
					<el-input placeholder="请输入关键字" v-model="addgoodsquery.key" clearable @keyup.enter.native="addmallgoodsdata" @change="addgoodsquery.ischange=true" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="addmallgoodsdata">查询</el-button>
				</el-form-item>
			</el-form>
			<el-table :data="addgoodslists" v-loading="addgoodsquery.loading" ref="multipleTable" @select="selectsingle"  @row-click="selectorder" @select-all="selectall">
				<el-table-column type="selection" width="30" align="center"></el-table-column>
				<el-table-column label="sku" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-rights-sku">{{scope.row.sku}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="400">
					<template slot-scope="scope">
						<div class="sys-offers-details-imgs">
							<i :class="scope.row.isgrounding==0 ? 'sys-offers-details-imgs-up' : 'sys-offers-details-imgs-down'">{{scope.row.isgrounding==0 ? '已上架' : '已下架'}}</i>
							<img :src="scope.row.img!='' ? scope.row.img : require('../../assets/goodsdefault.png')"/>
						</div>
						<div class="sys-offers-details-rights">
							<span class="sys-offers-details-rights-name">{{scope.row.name}}</span>
							<span class="sys-offers-details-rights-spec">{{scope.row.property_name}}</span>
							<span class="sys-offers-details-rights-agent">{{scope.row.agentname}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="所属品牌" align="center" width="140">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.brandname}}</span>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==1">未授权</i>
						<i class="sys-offers-details-brand-grant-yes" v-if="scope.row.brandname!='' && scope.row.brandtype==2">已授权</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==3">授权失败</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==4">授权未开始</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==5">授权到期</i>
					</template>
				</el-table-column>
				<el-table-column label="重量（kg）" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.weight}}</span>
					</template>
				</el-table-column>
				<el-table-column label="可用库存" align="center" width="100">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.inventorys}}</span>
					</template>
				</el-table-column>
				<el-table-column label="销售价格" align="center">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.property_price}}</span>
					</template>
				</el-table-column>
			</el-table>
			<div class="block">
	        	<!--分页begin-->
	            <el-pagination
		            @size-change="PageSizeChange"
		            @current-change="PageCurrentChange"
		            :current-page="addgoodsquery.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="addgoodsquery.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="addgoodsrows">
	            </el-pagination>
	            <!--分页end-->
	      	</div>
			<div slot="footer" class="dialog-footer">
			    <el-button size="small" @click="addgoodsDialog = false">取 消</el-button>			        
			    <el-button size="small" type="primary" @click="addgoodstoactive">保 存</el-button>
		    </div>
		</el-dialog>

		<!-- 批量设置活动价格 -->
		<el-dialog title="批量设置商品价格" :visible.sync="settingpriceDialog" width="45%" top="10vh">
			<div class="sys-offers-price-setting">
				<div class="sys-offers-price-setting-title">设置价格类型</div>
				<div class="sys-offers-price-setting-content" style="margin-left:20px">
					<el-radio v-model="settingpricequery.type" label="1">根据商品价格设置</el-radio>
  					<el-radio v-model="settingpricequery.type" label="2">统一价</el-radio>
				</div>
			</div>
			<div class="sys-offers-price-setting" v-if="settingpricequery.type==1">
				<div class="sys-offers-price-setting-content">
					<div class="sys-offers-price-setting-content-info">商品销售价格</div>
					<div class="sys-offers-price-setting-content-info">*</div>
					<div class="sys-offers-price-setting-content-info" style="width:20%">
						<el-input v-model="settingpricequery.percent" size="small">
							<template slot="append">%</template>
						</el-input>
					</div>
					<div class="sys-offers-price-setting-content-info">+</div>
					<div class="sys-offers-price-setting-content-info" style="width:20%">
						<el-input v-model="settingpricequery.plus" size="small">
							<template slot="append">元</template>
						</el-input>
					</div>
					<div class="sys-offers-price-setting-content-info">-</div>
					<div class="sys-offers-price-setting-content-info" style="width:20%">
						<el-input v-model="settingpricequery.minus" size="small">
							<template slot="append">元</template>
						</el-input>
					</div>
				</div>
			</div>
			<div class="sys-offers-price-setting" v-if="settingpricequery.type==2">
				<div class="sys-offers-price-setting-content-info" style="width:30%">
					<el-input v-model="settingpricequery.price" size="small">
						<template slot="append">元</template>
					</el-input>
				</div>
			</div>
			
			<div slot="footer" class="dialog-footer">
			    <el-button size="small" @click="settingpriceDialog = false">取 消</el-button>			        
			    <el-button size="small" type="primary" @click="changeactiveprice">保 存</el-button>
		    </div>
		</el-dialog>


		<!-- 品牌有问题的商品集中展示处理 -->
		<el-dialog title="品牌授权异常商品" :visible.sync="showbrandquery.dialog" width="60%" top="10vh">
			<div class="sys-offers-notice-warning">
				<div class="sys-offers-notice-warning-font">注：参加活动的商品必须是有品牌的商品，且品牌授权必须通过平台审核</div>
			</div>
			<div class="sys-offers-details-lists-info-main" style="margin:0 0 30px 0">
			<el-table :data="showbrandquery.data">
				<el-table-column label="sku" width="120" fixed="left">
					<template slot-scope="scope">
						<span class="sys-offers-details-rights-sku">{{scope.row.sku}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="500" fixed="left">
					<template slot-scope="scope">
						<div class="sys-offers-details-imgs">
							<i :class="scope.row.isgrounding==0 ? 'sys-offers-details-imgs-up' : 'sys-offers-details-imgs-down'">{{scope.row.isgrounding==0 ? '已上架' : '已下架'}}</i>
							<img :src="scope.row.img!='' ? scope.row.img : require('../../assets/goodsdefault.png')" style="width:90%;height:90%;margin-top:5%;margin-left:5%;"/>
						</div>
						<div class="sys-offers-details-rights">
							<span class="sys-offers-details-rights-name">{{scope.row.name}}</span>
							<span class="sys-offers-details-rights-spec">{{scope.row.property_name}}</span>
							<span class="sys-offers-details-rights-agent">{{scope.row.agentname}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="所属品牌" align="center">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.brandname}}</span>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==1">未授权</i>
						<i class="sys-offers-details-brand-grant-yes" v-if="scope.row.brandname!='' && scope.row.brandtype==2">已授权</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==3">授权失败</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==4">授权未开始</i>
						<i class="sys-offers-details-brand-grant-no" v-if="scope.row.brandname!='' && scope.row.brandtype==5">授权到期</i>
					</template>
				</el-table-column>
			</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
			    <el-button size="small" @click="showbrandquery.dialog = false">取 消</el-button>			        
			    <el-button size="small" type="danger" @click="delbugbrands">全部删除异常商品</el-button>
		    </div>
		</el-dialog>



		<!-- 有问题的商品集中展示处理 -->
		<el-dialog title="录入信息异常商品" :visible.sync="showerrorgoodsquery.dialog" width="80%" top="10vh">
			<div class="sys-offers-notice-warning">
				<div class="sys-offers-notice-warning-font">
					注：1、活动价不能为空或0或负数，必须是自然数<br/>
					    2、商品参加活动总数量不能为空或0或负数、必须是正整数<br/>
					    3、商品如果限购则限购数量不能为空或0或负数<br/>
						4、商品的每人限购数量不能大于商品参加活动总数量
				</div>
			</div>
			<div class="sys-offers-details-lists-info-main" style="margin:0 0 30px 0">
			<el-table :data="showerrorgoodsquery.data">
				<el-table-column label="sku" width="120" fixed="left">
					<template slot-scope="scope">
						<span class="sys-offers-details-rights-sku">{{scope.row.sku}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="400" fixed="left">
					<template slot-scope="scope">
						<div class="sys-offers-details-imgs">
							<i :class="scope.row.isgrounding==0 ? 'sys-offers-details-imgs-up' : 'sys-offers-details-imgs-down'">{{scope.row.isgrounding==0 ? '已上架' : '已下架'}}</i>
							<img :src="scope.row.img!='' ? scope.row.img : require('../../assets/goodsdefault.png')" style="width:90%;height:90%;margin-top:5%;margin-left:5%;"/>
						</div>
						<div class="sys-offers-details-rights">
							<span class="sys-offers-details-rights-name">{{scope.row.name}}</span>
							<span class="sys-offers-details-rights-spec">{{scope.row.property_name}}</span>
							<span class="sys-offers-details-rights-agent">{{scope.row.agentname}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="销售价格" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.property_price}}</span>
					</template>
				</el-table-column>
				<el-table-column label="活动价" align="center" width="120">
					<template slot-scope="scope">
						<el-input placeholder="请输入活动价" v-model="scope.row.active_price" size="small" clearable/>
					</template>
				</el-table-column>
				<el-table-column label="商品参加活动总数量" align="center" width="140">
					<template slot-scope="scope">
						<el-input placeholder="商品参加活动总数量" v-model="scope.row.inventory" size="small" clearable/>
					</template>
				</el-table-column>
				<el-table-column label="是否限购" align="center" width="120">
					<template slot-scope="scope">
						<el-switch active-color="#67C23A" inactive-color="#cccccc" v-model="scope.row.islimit"/>
					</template>
				</el-table-column>
				<el-table-column label="限制规则" align="center">
					<!-- <template slot-scope="scope">
						<el-input placeholder="请输入每人限购数量" v-model="scope.row.limitsingle" size="small" :disabled="scope.row.islimit==0 ? true : false" clearable/>
					</template> -->
					<template slot-scope="scope">
						<div style="display: flex;align-items: center;">
							<el-select 
								v-model="scope.row.limit_rule"
								size="small"
								placeholder="请选择"
								style="width: 130px;margin-right: 5px;flex-shrink: 0;"
							>
								<el-option label="每人限购数量" value="1"></el-option>
								<el-option label="每店限购数量" value="2"></el-option>
							</el-select>
							<el-input placeholder="请输入限购数量" v-model="scope.row.limitsingle" size="small" :disabled="scope.row.islimit==0 ? true : false" clearable/>
						</div>
					</template>
				</el-table-column>
			</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
			    <el-button size="small" @click="showerrorgoodsquery.dialog = false">取 消</el-button>			        
			    <el-button size="small" type="danger" @click="delbuggoods">保存设置</el-button>
		    </div>
		</el-dialog>



		<!-- 有商品参加了别的活动集中展示处理 -->
		<el-dialog title="商品活动时间重叠异常" :visible.sync="showerrorjoinactivequery.dialog" width="65%" top="10vh">
			<div class="sys-offers-notice-warning">
				<div class="sys-offers-notice-warning-font">
					注：同一个商品在同一时间、同一类型的活动里只能参加一个，以下商品已在相同的时间里参加了别的活动
				</div>
			</div>
			<div class="sys-offers-details-lists-info-main" style="margin:0 0 30px 0">
			<el-table :data="showerrorjoinactivequery.data">
				<el-table-column label="sku" width="120" fixed="left">
					<template slot-scope="scope">
						<span class="sys-offers-details-rights-sku">{{scope.row.sku}}</span>
					</template>
				</el-table-column>
				<el-table-column label="商品信息" width="400" fixed="left">
					<template slot-scope="scope">
						<div class="sys-offers-details-imgs">
							<i :class="scope.row.isgrounding==0 ? 'sys-offers-details-imgs-up' : 'sys-offers-details-imgs-down'">{{scope.row.isgrounding==0 ? '已上架' : '已下架'}}</i>
							<img :src="scope.row.img!='' ? scope.row.img : require('../../assets/goodsdefault.png')" style="width:90%;height:90%;margin-top:5%;margin-left:5%;"/>
						</div>
						<div class="sys-offers-details-rights">
							<span class="sys-offers-details-rights-name">{{scope.row.name}}</span>
							<span class="sys-offers-details-rights-spec">{{scope.row.property_name}}</span>
							<span class="sys-offers-details-rights-agent">{{scope.row.agentname}}</span>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="活动名称" align="center" width="120">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.activename}}</span>
					</template>
				</el-table-column>
				<el-table-column label="参加时间" align="center">
					<template slot-scope="scope">
						<span class="sys-offers-details-status">{{scope.row.jointime}}</span>
					</template>
				</el-table-column>
			</el-table>
			</div>
			<div slot="footer" class="dialog-footer">
			    <el-button size="small" @click="showerrorjoinactivequery.dialog = false">取 消</el-button>			        
			    <el-button size="small" type="danger" @click="delbugactive">全部删除异常商品</el-button>
		    </div>
		</el-dialog>


	</div>
  </transition>  
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
        url:this.GLOBAL.domain+"SysOffers/index",
        actionauth:'', //功能权限
		isjoin:false, //是否已报名
		jointype:'',  //显示类型
		showjoinlabel:0, //展示已报名动画
		stepindex:0, //第几部
		mainmarginleft:0, //主要步骤页面滑动
		goodslists:[{},{}],
		joinquery: {
			act:'sysaddjoin',
			token:this.$cookies.get('token'),
			id:'',
			name:'',
			unified:'',
			type:'',
			content:'',
			activetime:'',
			jointime:'',
			myjoindate:'',
			cuteverystarttime:'',
			cuteveryendtime:'',
			activestatus:'',
			joinstatus:'',
			jointype:'',
			reason:'',
			loading:false,
			joininfos:[
				{id:'',sku:'',goodsid:'',property_name:'',property_price:'',img:'',type:'',weight:'',unit:'',parentagentid:'',name:'',isgrounding:'',agentname:'',active_price:'',inventory:'',islimit:'',limitsingle:''}
			],
			goodsjson:'',
		},

		brandquery: {
			act:'lists',
			token:this.$cookies.get('token'),
			jdshow:0,
			rollpage:100000
	    },
		brandlists:[],
		groundinglists:[{id:1,name:'已上架'},{id:2,name:'已下架'}],
		saleagents:[],
		
		addgoodsDialog:false,
		addgoodsquery: {
			act:'getmallgoodsproperty',
			token:this.$cookies.get('token'),
			agentid:'',
			brandid:'',
			key:'',
			isgrounding:'',
			ischange:false,
			loading:false,
			p:1,
			rollpage:10
		},
		addgoodslists:[],
		addgoodsrows:0,
		addgoodstemps:[],

		settingpriceDialog:false,
		settingpricequery: {
			type:'1', //1、统一价格 2、根据商品价格
			price:'',
			percent:'',
			plus:0,
			minus:0,
		},

		showbrandquery: {
			dialog:false,
			loading:false,
			data:[],
		},
		showerrorgoodsquery: {
			dialog:false,
			loading:false,
			data:[],
		},
		showerrorjoinactivequery: {
			dialog:false,
			loading:false,
			data:[],
		},
		
    }
  },
    
  mounted(){  
    this.getactionauth();
	this.getBrand(); //获取品牌信息
	this.getagents(); //获取当前在售商品的代理商信息
	this.getmysysactiveinfos(this.childdata.sysactid); //获取我的报名信息详情
	
  },

  watch: {
	  childdata(val) {
		  if(val.sysactid!=this.joinquery.id) {
			  this.$confirm('当前正在编辑其他活动的报名信息，是否要进行切换覆盖，是否确定 ？', { type: 'warning' }).then(() => {
				  this.getmysysactiveinfos(val.sysactid); //获取我的报名信息详情
			  }).catch(() => {
								
			  });
		  }
	  },
  },
  
  methods:{

	  /** 修改时间 **/
	  changemytime() {
		  var resource = this.$resource(this.url);
		  resource.save({act:'changemydate',activeid:this.joinquery.id,date:this.joinquery.myjoindate,token:this.$cookies.get('token')}).then((res) => {
		  		if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
		  		}else{
					this.getmysysactiveinfosdata(this.joinquery.id);
			    }
		  }).catch((res) => {
				
		  });
	  },

	  /** 保存批量修改价格 **/
	  changeactiveprice() {
		this.$confirm('您是否用当前的设置方法对已添加的活动商品价格进行批量调整 ？', { type: 'warning' }).then(() => {
			var resource = this.$resource(this.url);
			resource.query({act:'changemoreprice',activeid:this.joinquery.id,type:this.settingpricequery.type,price:this.settingpricequery.price,
							percent:this.settingpricequery.percent,plus:this.settingpricequery.plus,minus:this.settingpricequery.minus,
							token:this.$cookies.get('token')}).then((res) => {
					if(res.data.Result>0){
						if(res.data.Result=='70001') this.$router.push('/login')
						this.$message.error(res.data.Message);
					}else{
						this.getmysysactiveinfosdata(this.joinquery.id);
						this.settingpriceDialog=false;
					}
			}).catch((res) => {
				
			});

        }).catch(() => {
            
        });   
	 },


	  /** 删除活动商品信息 **/
	  delactivegoods(item) {
		  var resource = this.$resource(this.url);
		  resource.save({act:'delactivegoods',activeid:this.joinquery.id,id:item.id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getmysysactiveinfosdata(this.joinquery.id);
				}
		  }).catch((res) => {
			
		  });
	  },


	  /** 修改每人限购数量 **/
	  changeislimitnums(item) {
		    var resource = this.$resource(this.url);
			resource.save({act:'changeislimitnums',activeid:this.joinquery.id,id:item.id,limitnums:item.limitsingle,limit_rule:item.limit_rule,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getmysysactiveinfosdata(this.joinquery.id);
				}
			}).catch((res) => {
				
			});
	  },


	  /** 修改商品是否限购 **/
	  changeislimit(item) {
		    var resource = this.$resource(this.url);
			resource.save({act:'changeislimit',activeid:this.joinquery.id,id:item.id,islimit:item.islimit,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getmysysactiveinfosdata(this.joinquery.id);
				}
			}).catch((res) => {
				
			});
	  },


	  /** 修改商品参加活动总数量 **/
	  changeinventory(item) {
		    var resource = this.$resource(this.url);
			resource.save({act:'changeactiveinventory',activeid:this.joinquery.id,id:item.id,inventory:item.inventory,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getmysysactiveinfosdata(this.joinquery.id);
				}
			}).catch((res) => {
				
			});
	  },


	  /** 修改商品活动价格 **/
	  changeprice(item) {
		    var resource = this.$resource(this.url);
			resource.save({act:'changeactiveprice',activeid:this.joinquery.id,id:item.id,price:item.active_price,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getmysysactiveinfosdata(this.joinquery.id);
				}
			}).catch((res) => {
				
			});
	  },


	  /** 保存删除的商品信息 **/
	  delbugactive() {
		  this.$confirm('您是否要全部删除上述已在别的活动里添加的商品，是否删除 ？', { type: 'warning' }).then(() => {
			  var ids=[];
			  this.showerrorjoinactivequery.data.forEach(function(t,i) {ids.push(t.id)});
			  var resource = this.$resource(this.url);
			  resource.save({act:'delactivegoods',activeid:this.joinquery.id,id:ids.join(','),token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.getmysysactiveinfosdata(this.joinquery.id);
					this.showerrorjoinactivequery.dialog=false;
				}
			  }).catch((res) => {
					
			  });
			  
		  }).catch(() => {
						
		  });
	  },


	  /** 查看商品参加活动期间是否参加了别的活动 **/
	  showerrorjoinactive(data) {
		  this.showerrorjoinactivequery.dialog=true;
		  this.showerrorjoinactivequery.loading=true;
		  this.showerrorjoinactivequery.data=[];
		  var _this=this; var number=-1; var param=[]; var ids=[];
		  data.forEach(function(item,i) {ids.push(item.id)});

		  this.joinquery.joininfos.forEach(function(item,i) {
			  number=-1;
			  number=ids.indexOf(item.id);
			  if(number >=0) param.push({id:item.id,sku:item.sku,img:item.img,name:item.name,agentname:item.agentname,isgrounding:item.isgrounding,
			  							 property_name:item.property_name,activename:data[number].activename,jointime:data[number].time});						 
		  });

		  this.showerrorjoinactivequery.data=param;
		  this.showerrorjoinactivequery.loading=false;
	  },

	
	  /** 保存编辑有问题的商品数据 **/
	  delbuggoods() {
		   this.$confirm('您是否变更上述商品信息，是否删除 ？', { type: 'warning' }).then(() => {
			  var resource = this.$resource(this.url);
			  resource.save({act:'changemoregoods',activeid:this.joinquery.id,data:JSON.stringify(this.showerrorgoodsquery.data),token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.showbrandquery.dialog=false;
					this.getmysysactiveinfosdata(this.joinquery.id);
					this.showerrorgoodsquery.dialog=false;
				}
			  }).catch((res) => {
					
			  });
			  
		  }).catch(() => {
						
		  });
	  },

	  /** 展示录入有问题的数据 **/
	  showerrorgoods(data) {
		  this.showerrorgoodsquery.dialog=true;
		  this.showerrorgoodsquery.loading=true;
		  this.showerrorgoodsquery.data=[];
		  var _this=this; var number=-1; var param=[];
		  
		  this.joinquery.joininfos.forEach(function(item,i) {
			  number=-1;
			  number=data.indexOf(item.id);
			  if(number >=0) {
				param.push({
					id:item.id,
					sku:item.sku,
					img:item.img,
					name:item.name,
					agentname:item.agentname,
					property_price:item.property_price,
			  		isgrounding:item.isgrounding,
					active_price:item.active_price,
					property_name:item.property_name,
					inventory:item.inventory,
					islimit:item.islimit,
					limitsingle:item.limitsingle,
					limit_rule: item.limit_rule,
				});
			  }					 
		  });
		  this.showerrorgoodsquery.data=param;
		  this.showerrorgoodsquery.loading=false;
	  },


	  /** 删除授权有问题的商品 **/
	  delbugbrands() {
		  this.$confirm('您是否要全部删除上述品牌授权有问题的商品，是否删除 ？', { type: 'warning' }).then(() => {
			  var ids=[];
			  this.showbrandquery.data.forEach(function(t,i) {ids.push(t.id)});
			  var resource = this.$resource(this.url);
			  resource.save({act:'delactivegoods',activeid:this.joinquery.id,id:ids.join(','),token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.showbrandquery.dialog=false;
					this.getmysysactiveinfosdata(this.joinquery.id);
				}
			  }).catch((res) => {
					
			  });
		  }).catch(() => {
						
		  });
	  },


	  /** 展示授权有问题的品牌信息 **/
	  showerrorbrands(data) {
		  this.showbrandquery.dialog=true;
		  this.showbrandquery.loading=true;
		  this.showbrandquery.data=[];
		  var _this=this; var number=-1;
		  
		  this.joinquery.joininfos.forEach(function(item,i) {
			  number=-1;
			  number=data.indexOf(item.id);
			  if(number >=0) {_this.showbrandquery.data.push(item);}
		  });
		  this.showbrandquery.loading=false;
	  },


	 /** 完成报名 **/
	 finishjoin() {
		 this.$confirm('您是否已确定参加活动的商品信息，一经提交就会进入待审核状态无法修改，是否确定 ？', { type: 'warning' }).then(() => {
			this.joinquery.goodsjson='';
			this.joinquery.goodsjson=JSON.stringify(this.joinquery.joininfos);
			var resource = this.$resource(this.url);
			this.joinquery.loading=true;
			this.joinquery.joininfos = []
			console.log(this.joinquery, '7777777777')
			
			resource.save(this.joinquery).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.joinquery.loading=false;
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					this.joinquery.loading=false;
					
					if(result.status==1) { //品牌授权有问题的商品信息
						this.showerrorbrands(result.data);
					}else if(result.status==2) { //商品录入由问题
						this.showerrorgoods(result.data);
					}else if(result.status==3) { //商品是否在参加活动期间已参加了别的活动
						this.showerrorjoinactive(result.data);
					}else if(result.status==4) { //参加活动成功
						this.$message.success('活动报名成功，等待审核');
						this.$emit('closechild','Sysoffersjoin'); //关闭窗口
						this.$emit('listenchild',{name:'平台营销活动',url:'Sysoffers',data:{issysoffersnew:1}});
					}

				}
			}).catch((res) => {
				this.joinquery.loading=false;
			});

		 }).catch(() => {
						
		 });
	 },


	/** 获取我的报名信息详情 **/
	getmysysactiveinfos(id) {
		this.getmysysactiveinfosdata(id);
		this.stepindex=0;
	},


	getmysysactiveinfosdata(id) {
		this.joinquery.id=id;
		this.joinquery.name='';
		this.joinquery.type='';
		this.joinquery.content='';
		this.joinquery.activetime='';
		this.joinquery.jointime='';
		this.joinquery.myjoindate='';
		this.joinquery.activestatus='';
		this.joinquery.joinstatus='';
		this.joinquery.jointype='';
		this.joinquery.unified='';
		this.joinquery.cuteverystarttime='';
		this.joinquery.cuteveryendtime='';
		this.joinquery.reason='';
		//this.joinquery.joininfos=[];
		//this.joinquery.loading=true;

		var resource = this.$resource(this.url);
		resource.query({act:'getmysysactiveinfos',id:id,token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.joinquery.loading=false;
			}else{
				var result = JSON.parse(Base64.decode(res.data.Data));
				this.joinquery.name=result.name;
				this.joinquery.unified=result.unified;
				this.joinquery.type=result.type;
				this.joinquery.content=result.content;
				this.joinquery.activetime=result.activetime;
				this.joinquery.jointime=result.jointime;
				this.joinquery.myjoindate=result.myjoindate;
				this.joinquery.activestatus=result.activestatus;
				this.joinquery.joinstatus=result.joinstatus;
				this.joinquery.jointype=result.jointype;
				this.joinquery.reason=result.reason;
				this.joinquery.cuteverystarttime=result.cuteverystarttime;
				this.joinquery.cuteveryendtime=result.cuteveryendtime;
				this.joinquery.joininfos=result.joininfos;
				this.joinquery.joininfos.forEach(function(item,i) {
					item.islimit==1 ? item.islimit=true : item.islimit=false;
				});
				//this.joinquery.loading=false;
			}
		}).catch((res) => {
			//this.joinquery.loading=false;
		});
	},


	/** 批量设置活动价格 **/
	settingpricemore() {
		this.settingpriceDialog=true;
		this.settingpricequery.type='1';
		this.settingpricequery.price='';
		this.settingpricequery.percent=100;
		this.settingpricequery.plus=0;
		this.settingpricequery.minus=0;
	},


    /** 获取商品信息，以sku为准 **/
	addmallgoods() {
		this.addgoodsDialog=true;
		this.addgoodsquery.agentid='';
		this.addgoodsquery.brandid='';
		this.addgoodsquery.key='';
		this.addgoodsquery.isgrounding='';
		this.addgoodsquery.p=1;
		this.addgoodsquery.rollpage=10;
		this.addgoodslists=[];
		this.addgoodsrows=0;
		this.addgoodstemps=[];
		this.addmallgoodsdata();
	},


	/** 获取新增商品信息 **/
	addmallgoodsdata() {
		if(this.addgoodsquery.ischange==true) {
      	  this.addgoodsquery.p=1;
      	  this.addgoodsquery.rollpage=10;
        }
		this.addgoodsquery.loading=true;
		var resource = this.$resource(this.url);
		resource.save(this.addgoodsquery).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.addgoodsquery.loading=false;
			}else{
				this.addgoodslists = JSON.parse(Base64.decode(res.data.Data));
				this.addgoodsrows=parseInt(res.data.count);
				this.addgoodsquery.loading=false;
				if(this.addgoodsquery.ischange) this.addgoodsquery.ischange=false;
				
				//组装已选中的商品信息
				var _this=this;
				var tempids=[];
				var number=-1;
				this.addgoodstemps.forEach(function(item,i) {tempids.push(item.id)});
				setTimeout(function() {
					_this.addgoodslists.forEach(function(item,i) {
						number=-1;number=tempids.indexOf(item.id);
						number==-1 ? '' : _this.$refs.multipleTable.toggleRowSelection(item);
					});
				},200);

			}
		}).catch((res) => {
			this.addgoodsquery.loading=false;
		});
	},
	PageSizeChange(val) {
        this.addgoodsquery.rollpage = val;
        this.addmallgoodsdata();
    },
    PageCurrentChange(val) {
        this.addgoodsquery.p = val;
        this.addmallgoodsdata();
    }, 

	/** 点击单行选择商品 **/
	selectorder(val,type) {
		var numbers=-1;
		this.addgoodstemps.forEach(function(item,i) {
			if(item.id==val.id) numbers=i;
		});

		numbers==-1 ? this.addgoodstemps.push(val) : this.$delete(this.addgoodstemps,numbers);
		if(type!='no') this.$refs.multipleTable.toggleRowSelection(val);
	},

	/** 点击单行单元格选择商品 **/
	selectsingle(row,val) {
		this.selectorder(val,'no');
	},


	/** 全选 / 全不选 **/
	selectall(val) {
		var _this=this;
		var addordel=val.length==0 ? false : true;
		var tempids=[];
		var numbers=-1;

		this.addgoodstemps.forEach(function(item,i) {tempids.push(item.id)});
		this.addgoodslists.forEach(function(item,i) {
			if(addordel) { //新增
				numbers=-1;numbers=tempids.indexOf(item.id);
				numbers==-1 ? _this.addgoodstemps.push(item) : '';
			}else { //删除
				numbers=-1;numbers=tempids.indexOf(item.id);
				numbers==-1 ? '' : _this.$delete(_this.addgoodstemps,numbers);
			}
		});
	},

	/** 添加商品信息到活动 **/
	addgoodstoactive() {
		if(this.addgoodstemps.length==0) {this.$message.error('请至少选择一个商品参加活动');return false;}
		var tempids=[];
		this.addgoodstemps.forEach(function(item,i) {tempids.push(item.id)});

		var resource = this.$resource(this.url);
		resource.save({act:'addgoodstoactivecart',activeid:this.joinquery.id,ids:tempids.join(','),token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.addgoodsDialog=false;
				this.getmysysactiveinfosdata(this.joinquery.id);
			}
		}).catch((res) => {
			
		});
	},


	/** 获取目前在售商品的代理商信息 **/
	getagents() {
		var resource = this.$resource(this.GLOBAL.domain+"Goods/index");
		resource.query({act:'getpushagentlists',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
			}else{
				this.saleagents = JSON.parse(Base64.decode(res.data.Data));
				if(this.saleagents.length==1) this.joinquery.agentid=saleagents[0].id;
			}
		}).catch((res) => {
			
		});
	},  


	/** 获取品牌 **/
	getBrand(){
	    var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
	    resource.query(this.brandquery).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.brandlists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        this.$message.error(this.GLOBAL.errortext);
	    });
	},

    /** 重置表单 **/
    reset() {
        this.$refs.create.resetFields();
    },
    
    //获取功能权限
    getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    //已报名特效
	showjoinanimote(jointype) {
		var _this=this;
		this.isjoin=false;
		this.showjoinlabel=false;
		this.jointype=jointype;
		setTimeout(function() {
			_this.isjoin=true;
			setTimeout(function() {
				_this.showjoinlabel=true;
			},200);
		},300);
	},

	//初始化第几步数据
	// stepindexFun() {
	// 	this.stepindex=0;
	// 	this.mainmarginleft=0;
	// },


	//点击上一步
	clickuppage() {
		this.changestep('up');
	},

	//点击下一步
	clicknext() {
		//拦截验证
		if(this.stepindex==0 || this.stepindex==1) {this.changestep('next');}
		if(this.stepindex==2) {
			if(this.joinquery.joininfos.length==0) {this.$message.error('请选择参加活动的商品');return false;}
			//检测录入商品数据是否异常
			var resource = this.$resource(this.url);
			resource.save({act:'checkgoodsbeforenext',id:this.joinquery.id,token:this.$cookies.get('token')}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					var result = JSON.parse(Base64.decode(res.data.Data));
					if(result.status==1) { //品牌授权有问题的商品信息
						this.showerrorbrands(result.data);
						return false;
					}else if(result.status==2) { //商品录入由问题
						this.showerrorgoods(result.data);
						return false;
					}else if(result.status==3) { //商品是否在参加活动期间已参加了别的活动
						this.showerrorjoinactive(result.data);
						return false;
					}else if(result.status==4) {
						this.changestep('next');
					}

				}
			}).catch((res) => {
				
			});

		}
		if(this.stepindex==3) {
			if(this.joinquery.myjoindate=='') {this.$message.error('请选择参加活动时间');return false;}
			this.changestep('next');
		}
		
	},


	//点击滑动模块逻辑
	changestep(type) {

		if(type=='up' && this.stepindex==0) return false; //到步骤一的时候点击上一步无效
		if(type=='next' && this.stepindex==4) return false; //到步骤四的时候点击下一步无效
		if(type=='up') { //上一步
			this.stepindex--;
			this.mainmarginleft+=100;

		}else { //下一步
			this.stepindex++;
			this.mainmarginleft-=100;
		}

	},



   } 
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.backborder3plus {background:#fff;border-radius:15px;border:1px solid #ddd;padding:2% 2% 3% 2%}
.sys-active-join-all .el-step__title{font-size:14px}
.sys-offers-details {display:inline-block;width:100%;margin-bottom:20px;position:relative}
.sys-offers-details-main {float:left;width:100%;}

.sys-offers-detail-isjoin-base-warning {position:absolute;background:#E6A23C;z-index:100;color:#fff;border-radius:15px;transform:rotate(-30deg);-ms-transform:rotate(-30deg);-moz-transform:rotate(-30deg);-webkit-transform:rotate(-30deg);-o-transform:rotate(-30deg);transition:.5s all;border:1px solid red}
.sys-offers-detail-isjoin-base-warning {position:absolute;background:#67C23A;z-index:100;color:#fff;border-radius:15px;transform:rotate(-30deg);-ms-transform:rotate(-30deg);-moz-transform:rotate(-30deg);-webkit-transform:rotate(-30deg);-o-transform:rotate(-30deg);transition:.5s all;border:1px solid red}
.sys-offers-detail-isjoin-base-danger {position:absolute;background:#F56C6C;z-index:100;color:#fff;border-radius:15px;transform:rotate(-30deg);-ms-transform:rotate(-30deg);-moz-transform:rotate(-30deg);-webkit-transform:rotate(-30deg);-o-transform:rotate(-30deg);transition:.5s all;border:1px solid red}
.sys-offers-detail-isjoin-yes-danger {width:7%;text-align:center;padding:3px 10px;font-size:12px;line-height:23px;margin-left:-4%;margin-top:-30px;}
.sys-offers-detail-isjoin-no-danger {width:100%;text-align:center;padding:100px 0;font-size:36px;line-height:72px;z-index:100;margin-left:-5%;margin-top:0%}

.sys-offers-details-main-line1 {float:left;width:5px;height:50px;border-radius:15px;background:#e6a23c;margin-right:1%}
.sys-offers-details-main-name {float:left;width:98%;font-size:14px;color:#666666;line-height:23px;margin-top:0px;font-weight:500}
.sys-offers-details-main-time {float:left;margin-right:3%;font-size:13px;color:#999999;line-height:23px;margin-top:3px;font-weight:400}
.sys-offers-details-main-active-status {font-size:12px;color:#fff;font-style:normal;margin-left:2px;padding:2px 10px;border-radius:15px}
.sys-active-status-end {background:#909399}
.sys-active-status-doing {background:rgb(103, 194, 58)}

.sys-offers-details-lists-info {display:inline-block;float:left;width:100%;border-radius:15px;position:relative;overflow:hidden;transition:.5s all;margin:50px 0 30px 0}
.sys-offers-details-lists-info-title {float:left;width:100%;font-size:15px;font-weight:500}
.sys-offers-details-lists-info-main {float:left;width:100%;margin-top:20px;font-size:13px;line-height:28px}

.sys-offers-details-imgs {display:flex;align-items: center;justify-content: center;float:left;width:60px;height:60px;border:1px solid #dddddd;border-radius:6px;background:rgba(221,221,221,.4);}
.sys-offers-details-imgs img {max-width:80%;max-height:80%;float:left;border-radius:6px}
.sys-offers-details-imgs-up {position:absolute;color:#fff;font-size:12px;line-height:13px;background:rgb(103, 194, 58);padding:2px 10px;border-radius:15px;font-style:normal;margin-left:-30px;margin-top:-60px}
.sys-offers-details-imgs-down {position:absolute;color:#fff;font-size:12px;line-height:13px;background:#909399;padding:2px 10px;border-radius:15px;font-style:normal;margin-left:-30px;margin-top:-60px}
.sys-offers-details-rights {float:left;margin-left:3%;width:80%}
.sys-offers-details-rights-sku {font-size:13px;}
.sys-offers-details-rights-name {float:left;width:100%;font-size:13px;line-height:23px;color:#666666;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.sys-offers-details-rights-spec {float:left;width:100%;font-size:12px;line-height:23px;color:#999999;overflow:hidden;white-space: nowrap;text-overflow: ellipsis;}
.sys-offers-details-rights-agent {float:left;font-style:normal;padding:0 10px;line-height:18px;border-radius:15px;color:#fff;background:#F56C6C;font-size:12px;margin-top:3px}

.sys-offers-details-status {float:left;width:100%;font-size:13px;color:#666666;line-height:23px}
.sys-offers-details-downline-time {float:left;width:100%;font-size:12px;color:#999999;line-height:23px;}

.sys-offers-details-brand-grant-no {font-size:12px;color:#fff;background:#909399;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}
.sys-offers-details-brand-grant-yes {font-size:12px;color:#fff;background:#67C23A;line-height:12px;padding:3px 0;border-radius:15px;font-style:normal;text-align:center;margin-top:5px;padding:3px 10px}

.sys-offers-price-setting {display:inline-block;width:100%;padding:10px 0}
.sys-offers-price-setting-title {display:inline-block;}
.sys-offers-price-setting-content {display:inline-block;}
.sys-offers-price-setting-content-info {display:inline-block;text-align:left;padding:0 5px}

.sys-offers-notice-warning {display:inline-block;width:100%;padding:10px 0}
.sys-offers-notice-warning-font {display:inline-block;font-size:13px !important;font-weight:500;padding:3px 2%;width:96%;line-height:23px;color:red;background:#dddddd;border-radius:6px}
</style>


// WEBPACK FOOTER //
// src/components/mall/Sysoffersjoin.vue